import { Typography } from "@mui/material";
import React from "react";

const WidgetTitle = ({ children, sx }) => {
  return (
    <Typography
      sx={{
        display: "flex",
        alignItems: "center",
        fontWeight: 600,
        // color: "#3E4756",
        color: "var(--blue)",
        fontFamily: " var(--serif)",
        // fontSize: "1.2rem",
        ...sx,
      }}
      variant="h2"
    >
      {children}
    </Typography>
  );
};

export default WidgetTitle;
